import styled from "styled-components";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";

export const Container = styled.section`
  display: grid;
  grid-template-rows: auto;
  padding: 0;
  width: 100%;
  max-width: 1468px;

  ${mediaQuery[Screen.xs]} {
    max-width: auto;
  }

  ${mediaQuery[Screen.sm]} {
    max-width: auto;
  }

  ${mediaQuery[Screen.md]} {
    max-width: 363px;
  }
`;
